function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { createGlobalStyle } from 'styled-components';
import { colors } from "./..";
var interfaceColor = {
  '--bui-background': colors.grey900,
  '--bui-background-secondary': colors.grey800,
  '--bui-background-error': colors.grey900,
  '--bui-background-selected': colors.grey800,
  '--bui-myads-card-background': colors.grey800,
  '--bui-border': colors.grey800,
  '--bui-divider': colors.grey800
};
var formColor = {
  '--bui-input-background': colors.grey900,
  '--bui-form-border': colors.grey600,
  '--bui-form-border-focus': colors.grey400,
  '--bui-form-border-success': colors.green500,
  '--bui-form-border-error': colors.yellow900
};
var textColor = {
  '--bui-text': colors.white100,
  '--bui-text-secondary': colors.grey300,
  '--bui-text-info': colors.blue800,
  '--bui-text-error': colors.yellow900,
  '--bui-text-success': colors.green500,
  '--bui-text-placeholder': colors.grey300,
  '--bui-textlink': colors.blue500,
  '--bui-textlink-hover': colors.blue300,
  '--bui-textlink-active': colors.blue700,
  '--bui-textlink-focus': colors.blue500,
  '--bui-textlink-visited': colors.purple200,
  '--bui-discount-price-text': colors.red300
};
var buttonColor = {
  '--bui-button-outline-focus': colors.grey600,
  '--bui-button-primary-text': colors.white100,
  '--bui-button-primary-background': colors.blue700,
  '--bui-button-primary-background-hover': colors.blue500,
  '--bui-button-primary-background-active': colors.blue900,
  '--bui-button-secondary-text': colors.white100,
  '--bui-button-secondary-background': colors.grey900,
  '--bui-button-secondary-border': colors.grey500,
  '--bui-button-secondary-border-hover': colors.grey300,
  '--bui-button-secondary-border-active': colors.grey700,
  '--bui-button-tertiary-text': colors.white100,
  '--bui-button-tertiary-background': 'transparent',
  '--bui-button-tertiary-background-hover': colors.grey700,
  '--bui-button-tertiary-background-active': colors.grey900
};
var notifications = {
  '--bui-notification-text': colors.white100,
  '--bui-notification-background': colors.red600
};
var infoCards = {
  '--bui-infocard-red-background': colors.red100,
  '--bui-infocard-red-text': colors.black100,
  '--bui-infocard-blue-background': colors.blue100,
  '--bui-infocard-blue-text': colors.black100,
  '--bui-infocard-green-background': colors.green100,
  '--bui-infocard-green-text': colors.black100,
  '--bui-infocard-yellow-background': colors.yellow100,
  '--bui-infocard-yellow-text': colors.black100
};
var gradients = {
  '--bui-gradient-vertical-primary': 'linear-gradient(0deg, rgba(34, 32, 31, 1) 0%, rgba(34, 32, 31, 0) 100%)'
};

var darkThemeObject = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, interfaceColor), formColor), textColor), buttonColor), notifications), infoCards), gradients);

var DarkTheme = createGlobalStyle([":root{", "}"], darkThemeObject);
export { darkThemeObject };
export default DarkTheme;
//# sourceMappingURL=DarkTheme.js.map